import { useEffect, useState } from "react";
import "./Details.css";
import General from "./General";
import Comparison_Two from "./Comparison_Two";

/* =========================================================
   HEADER SKELETON
   ========================================================= */

function HeaderSkeleton() {
  return (
    <div className="header-section skeleton-header">
      <div className="skeleton skeleton-league"></div>

      <div className="skeleton-matchup">
        <div className="skeleton-team">
          <div className="skeleton skeleton-team-name"></div>
          <div className="skeleton skeleton-team-pos"></div>
        </div>

        <div className="skeleton skeleton-vs"></div>

        <div className="skeleton-team">
          <div className="skeleton skeleton-team-name"></div>
          <div className="skeleton skeleton-team-pos"></div>
        </div>

        <div className="skeleton skeleton-time"></div>
      </div>
    </div>
  );
}

/* =========================================================
   PREDICTION / GENERAL DATA SKELETON
   ========================================================= */

function PredictionSkeleton() {
  return (
    <div className="body_section">
      <div className="general">
        {Array.from({ length: 4 }).map((_, index) => (
          <div className="general-skeleton-card" key={index}>
            <div className="skeleton skeleton-card-title"></div>

            <div className="skeleton skeleton-line"></div>

            <div className="skeleton skeleton-line"></div>

            <div className="skeleton skeleton-line short"></div>

            <div className="skeleton skeleton-line"></div>

            <div className="skeleton skeleton-line short"></div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* =========================================================
   FORM SKELETON
   ========================================================= */

function FormSkeleton() {
  return (
    <div className="form_selection form-skeleton">
      <div className="skeleton skeleton-form-title"></div>

      {Array.from({ length: 9 }).map((_, index) => (
        <div className="skeleton skeleton-option" key={index}></div>
      ))}

      <div className="skeleton skeleton-submit"></div>
    </div>
  );
}

/* =========================================================
   MAIN DETAILS COMPONENT
   ========================================================= */

export default function Details({ teamcode, odds, algorithms, setdisplay }) {
  const [TeamData, setTeamData] = useState(null);

  const [selectedOption, setSelectedOption] = useState("");
  const API_URL = process.env.REACT_APP_API_FAST || "http://192.168.1.103:8000";

  const [Prediction, setPrediction] = useState(false);
  console.log("odds_data", odds);
  

  /* =========================================================
     FETCH TEAM DATA
     ========================================================= */

  useEffect(() => {
    if (!teamcode) {
      setTeamData(null);
      return;
    }

    const fetchTeam = async () => {
      try {
        // Clear previous team's data immediately.
        // This causes the skeleton to appear while
        // the new team is being fetched.
        setTeamData(null);

        const response = await fetch(
          `${API_URL}/team/${teamcode}`
        );

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }

        const data = await response.json();

        console.log("Team data:", data);

        setTeamData(data);
      } catch (err) {
        console.error("Error fetching team:", err);
      }
    };

    fetchTeam();
  }, [teamcode]);

  /* =========================================================
     FORMATTED TIME
     ========================================================= */

  const formattedTime = TeamData?.Time
    ? new Date(TeamData.Time).toLocaleString("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "";

  /* =========================================================
     SUBMIT PREDICTION
     ========================================================= */

  const [activeView, setActiveView] = useState("general");
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedOption) {
      alert("Please select a prediction");
      return;
    }

    if (activeView === "general") {
      setPrediction(selectedOption);
      setActiveView("comparison");

      console.log("Initial prediction:", selectedOption);

      return;
    }

    if (activeView === "comparison") {
      try {
        const response = await fetch(
          `${API_URL}/virtual/select_team`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              teamcode: teamcode,
              prediction: selectedOption,
            }),
          }
        );
        console.log("HTTP status:", response.status);
        console.log("HTTP OK:", response.ok);
        const data = await response.json();
        console.log("Added to virtual table:", data);
        if (response.status === 404) {
          alert(data.detail);
          return;
        }

        if (!response.ok) {
          alert(data.detail || "Something went wrong");
          return;
        }
        setdisplay(false);
      } catch (error) {
        console.error("Error submitting prediction:", error);
      }
    }
  };

  /* =========================================================
     RENDER
     ========================================================= */

  return (
    <div className="main_details_section">
      {/* =====================================================
          CLOSE BUTTON
          ===================================================== */}

      <button
        className="futuristic-close-btn"
        onClick={() => setdisplay(false)}
        aria-label="Close"
      >
        <span className="close-icon">×</span>
      </button>

      {/* =====================================================
          HEADER

          DATA AVAILABLE:
              Real header

          DATA LOADING:
              Skeleton header
          ===================================================== */}

      {TeamData ? (
        <div className="header-section">
          <h2 className="league-name">{TeamData?.League?.toUpperCase()}</h2>

          <div className="match-header">
            {/* LEFT: ALGORITHMS */}
            <div className="algorithm-section">
              <div className="section-title">ALGORITHMS</div>

              {algorithms?.length > 0 ? (
                <table className="algorithm-table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Pred</th>
                      <th>Total</th>
                      <th>Confidence</th>
                      <th>Overall</th>
                      <th>Rank</th>
                    </tr>
                  </thead>

                  <tbody>
                    {algorithms.map((algo, index) => (
                      <tr key={algo.algo_id || index}>
                        <td className="algo-id-cell">
                          <span className="algo-id">
                            {algo.algo_id}
                            <span className="algo-name-tooltip">
                              {algo.algo_name}
                            </span>
                          </span>
                        </td>

                        <td>{algo.prediction}</td>
                        <td>{algo.total_g}</td>
                        <td>{algo.confidence}%</td>
                        <td>{algo.accuracy}%</td>
                        <td>#{algo.rank}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <span className="no-algorithm">No algorithm</span>
              )}
            </div>

            {/* MIDDLE: MATCH DETAILS */}
            <div className="matchup-container">
              <div className="team">
                <div className="team-name">{TeamData?.Team_A}</div>

                <div className="team-pos">#{TeamData?.H_pos}</div>
              </div>

              <div className="vs">VS</div>

              <div className="team">
                <div className="team-name">{TeamData?.Team_B}</div>

                <div className="team-pos">#{TeamData?.A_pos}</div>
              </div>

              <span className="match-time">{formattedTime}</span>
            </div>

            {/* RIGHT: MORE DETAILS */}
            <div className="details-section">
              <a
                href={TeamData?.link_tag}
                target="_blank"
                rel="noopener noreferrer"
                className="more-details"
              >
                more details →
              </a>
            </div>
          </div>
        </div>
      ) : (
        <HeaderSkeleton />
      )}

      {/* =====================================================
          BODY

          IMPORTANT:

          If TeamData exists:
              Show actual General components + form

          If TeamData is null:
              Show prediction skeleton + form skeleton
          ===================================================== */}

      {TeamData ? (
        <>
          {/* =================================================
                GENERAL PREDICTION DATA
                ================================================= */}

          <div className="body_section">
            {activeView === "general" && (
              <div className="general">
                <General
                  tablename="general_ratio_calc"
                  teamcode={teamcode}
                  title="GENERAL CALCULATIONS"
                />

                <General
                  tablename="odds_ratio_calc"
                  teamcode={teamcode}
                  title="ODDS RATIO ANALYSIS"
                />

                <General
                  tablename="recent_form_ratio_calc"
                  teamcode={teamcode}
                  title="RECENT FORM ANALYSIS"
                />

                <General
                  tablename="general_decay"
                  teamcode={teamcode}
                  title="GENERAL DECAY CALC"
                />
              </div>
            )}
            {activeView === "comparison" && Prediction && (
              <Comparison_Two
                Prediction={Prediction}
                teamcode={teamcode}
                setdisplay={setdisplay}
              />
            )}
          </div>

          {/* =================================================
                PREDICTION FORM
                ================================================= */}
          <div className="form_selection">
            <form onSubmit={handleSubmit}>
              <p>Select your prediction:</p>

              {Object.entries(odds || {}).map(([key, value]) => (
                <label key={key}>
                  <input
                    type="radio"
                    value={key}
                    checked={selectedOption === key}
                    onChange={(e) => setSelectedOption(e.target.value)}
                  />

                  {key}

                  <span>{value}</span>
                </label>
              ))}

              <button type="submit" disabled={!selectedOption}>
                Submit
              </button>
            </form>
          </div>
        </>
      ) : (
        /* =================================================
             LOADING STATE
             ================================================= */

        <>
          <PredictionSkeleton />

          <FormSkeleton />
        </>
      )}

      {/* =====================================================
          COMPARISON / PREDICTION RESULT
          ===================================================== */}
    </div>
  );
}
